<div class="flex flex-col rounded border border-solid border-slate-200">
  <div class="flex flex-row flex-wrap items-center gap-2 bg-slate-100 p-2">
    <pr-campaign-entry-status [status]="entry().status" />

    @if (entry() | map: getCampaign$ : this | async; as campaign) {
      <div class="flex grow font-bold">{{ campaign.name }}</div>
    } @else {
      <div class="flex grow font-bold">Unknown Campaign</div>
    }

    <button mat-icon-button [matMenuTriggerFor]="entryMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #entryMenu="matMenu">
      <a
        mat-menu-item
        [prBrandRouterLink]="
          (entry() | map: brandLinks.marketingCampaignEntry).segments
        "
      >
        View Entry
      </a>
      @if (menuActions$ | async; as actions) {
        @if (actions.length) {
          <mat-divider />
          @for (action of actions; track action.label) {
            <button
              mat-menu-item
              matTooltipPosition="right"
              [matTooltip]="action.tooltip"
              (click)="action.run()"
            >
              <mat-icon [ngClass]="action.iconColorClass ?? ''">{{
                action.icon
              }}</mat-icon>
              <span>{{ action.label }}</span>
            </button>
          }
        }
      }
    </mat-menu>
  </div>
  <div class="px-4">
    <pr-campaign-entry-progress [campaignEntry]="entry()" />
  </div>
</div>
